import React, { useContext, useEffect } from 'react'
import { LocationContext } from '../../../context/LocationContext'
import { Form } from 'react-bootstrap';

const DistrictFilter = ({ className = " ", required, setCurrentPage,disabled = false }) => {
    const { districtList, fetchDistricts, selectedDistrictId, setSelectedDistrictId } = useContext(LocationContext);
    const handleChange = (e) => {
        setSelectedDistrictId(e.target.value);
        if (setCurrentPage) {   // 👈 only call if passed
            setCurrentPage(1);
        }
    };
    useEffect(() => {
        fetchDistricts()
    }, [])
    return (
        <>
            <div className="">
                <Form.Select
                    value={selectedDistrictId}
                    onChange={handleChange}
                    className={`me-2 ${className}`}
                    style={{ width: "100%", padding: "11px 50px 10px 11px" }}
                    required={required}
                    disabled={disabled}

                > <option value="">All District</option>
                    {districtList.map((item) => {
                        return (
                            <>

                                <option key={item.id} value={item.id}>{item?.label}</option>
                            </>
                        )
                    })}


                </Form.Select>
            </div>
        </>
    )
}

export default DistrictFilter
